import { Box, Typography } from '@mui/material';
import React from 'react';

import GlobalBlockRenderer from '@/components/ContentBlocks/GlobalBlockRenderer/GlobalBlockRenderer';
import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';

import { getCalculatorTitleStyles } from './CalculatorStyles';

interface CalculatorLayoutProps {
  title?: string | undefined;
  blurb?: any;
  backgroundOptions?: StrapiBackgroundOptions;
  displayOptions?: StrapiDisplayOptions;
  dataComponent: string;
  rowLayout?: boolean;
  children: React.ReactNode;
}

export const CalculatorLayout = ({
  title = undefined,
  blurb,
  backgroundOptions = undefined,
  displayOptions = undefined,
  dataComponent,
  children,
}: CalculatorLayoutProps) => {
  const words = title ? title.split(' ') : undefined;

  return (
    <CustomBackground
      backgroundOptions={backgroundOptions ?? undefined}
      displayOptions={
        displayOptions ?? {
          PaddingInline: 'xs',
        }
      }
      boxProps={{
        // @ts-expect-error - actually does support data props
        'data-component': dataComponent,
      }}
    >
      {words && (
        <Typography variant="h2" textAlign="center" sx={getCalculatorTitleStyles()}>
          {words.slice(0, words.length - 1).join(' ')}
          <strong>{words[words.length - 1]}</strong>
        </Typography>
      )}
      {blurb && (
        <Box pt={2} px={7}>
          <GlobalBlockRenderer content={blurb} />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          px: { xs: 1, sm: 1 },
          py: 3,
        }}
      >
        {children}
      </Box>
    </CustomBackground>
  );
};
